// extracted by mini-css-extract-plugin
export default {"container":"StdInfo_container__m+1+U","icon-container":"StdInfo_icon-container__etHOx","text":"StdInfo_text__e44qt","empty":"StdInfo_empty__oT0So"};